import {
  REPORT_TYPES,
  createNavigationListener,
  navigate,
  report,
} from '@adsk/exo-skeleton-api';

import { extractSource } from '../components/ExoSkeletonApi/ExoSkeletonApi';
import { EXO_SKELETON_SCOPE_NAME } from '../consts';

export const NAVIGATE_EVENT_NAME = 'exo-skeleton:navigate' as const;
export interface NavigateEventDetail {
  to: string;
  source: string | undefined;
}

declare global {
  interface Window {
    exoNavigate: (to: string) => void;
  }

  interface WindowEventMap {
    [NAVIGATE_EVENT_NAME]: CustomEvent<NavigateEventDetail>;
  }
}

export function initializeNavigationHandler() {
  /**
   * @deprecated Please use "navigate" function from "@adsk/exo-skeleton-api" instead.
   */
  window.exoNavigate = (to: string) => {
    void report({
      scope: EXO_SKELETON_SCOPE_NAME,
      type: REPORT_TYPES.warning,
      value: `window.exoNavigate is deprecated, please use navigate('...') instead from '@adsk/exo-skeleton-api'`,
      context: {
        to,
      },
    });

    return navigate(to);
  };

  return createNavigationListener({
    onNavigate({ data }) {
      const source = extractSource(data);
      const { to } = data;

      const navigationEvent = new CustomEvent(NAVIGATE_EVENT_NAME, {
        detail: { to, source } satisfies NavigateEventDetail,
      });

      window.dispatchEvent(navigationEvent);
    },
  });
}
